module.exports = __webpack_public_path__ + "static/img/アセット 50@3x.4a36483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 50@3x.png
// module id = vjRZ
// module chunks = 1